module.exports = __webpack_public_path__ + "img/flexibility.ad98de39.png";